<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">SGK Şubesi</label>
            <v-validator :errors="errors" parameter="BranchId" :watch="sgkBranch">
                <v-select-list :options="sgkBranches" label="Name" v-model="sgkBranch" placeholder="SGK Şube"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12">
            <!-- Etiket kayıt tipine göre: çıkış kaydı düzenlenirken "İşe Giriş Tarihi" yanıltıcıydı. -->
            <label class="form-label">{{ dateLabel }}</label>
            <v-validator :errors="errors" parameter="Date" :watch="value.Date">
                <v-date-picker v-model="value.Date" :placeholder="dateLabel"></v-date-picker>
            </v-validator>
        </div>
        <template v-if="value.Type == 'CIKIS'">
            <div class="col-12 mt-1">
                <b-form-checkbox v-model="value.EYT">EYT</b-form-checkbox>
            </div>
            <div class="col-12 mt-1">
                <!-- Personelin kendi kaydına (Employee.Harmful) yazılır; giriş ekranındaki uyarı bundan okunur. -->
                <b-form-checkbox class="custom-control-danger text-danger" v-model="value.Harmful">Tekrar işe alımı sakıncalıdır</b-form-checkbox>
            </div>
            <div class="col-12 mt-1" v-if="value.Harmful">
                <!-- Çıkış talebi ekranındaki desenle aynı: işaret varsa sebep alanı açılır. -->
                <label class="form-label">Sakınca Nedeni</label>
                <textarea class="form-control" v-model="value.HarmfulReason" placeholder="Sakınca Nedeni"></textarea>
            </div>
            <div class="col-12 mt-1">
                <!-- Çıkış kaydının kendisine yazılır (SGKJobNotice.Dummy). -->
                <b-form-checkbox v-model="value.Dummy">Dummy</b-form-checkbox>
            </div>
        </template>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import VValidator from '@/components/VValidator.vue';
import { BFormCheckbox } from 'bootstrap-vue';

export default {
    components:{
        VValidator,
        BFormCheckbox
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return {
            sgkBranches:[]
        }
    },
    mounted(){
        this.getBranches()
    },
    methods:{
        getBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sgkBranches = res.data.Data
            })
        },
    },
    computed:{
        sgkBranch:{
            get:function(){
                return this.sgkBranches.find(b=>b.Id==this.value.BranchId)
            },
            set:function(value){
                this.value.BranchId = value?.Id || null
            }
        },
        // Type: 'GIRIS' | 'CIKIS' | 'TRANSFER' (EmployeeJobNotices.vue update() içinde set edilir).
        dateLabel(){
            if(this.value.Type == 'CIKIS') return 'İşten Çıkış Tarihi'
            if(this.value.Type == 'TRANSFER') return 'Nakil Tarihi'
            return 'İşe Giriş Tarihi'
        },
    }
}
</script>